module.exports = __webpack_public_path__ + "img/map.b90018ec.png";